import { IItemWithString } from 'lib/type/common';

export function getEmailDomainNames(emailDomains: IItemWithString[] | undefined): string[] {
  return (emailDomains ?? [])
    .map((item) => String(item?.fields?.name?.value ?? '').trim())
    .filter(Boolean);
}

export function buildEmailDomainSuggestions(
  emailValue: string | undefined,
  domainNames: string[]
): string[] {
  const value = String(emailValue ?? '');
  const atIndex = value.indexOf('@');
  if (atIndex < 1) {
    return [];
  }
  const prefix = value.slice(0, atIndex + 1);
  return domainNames.map((domain) => `${prefix}${domain}`);
}

export function filterEmailDomainSuggestions(options: string[], inputValue: string): string[] {
  const input = String(inputValue ?? '')
    .trim()
    .toLowerCase();
  if (input.indexOf('@') < 1) {
    return [];
  }
  return options.filter((option) => option.toLowerCase().startsWith(input));
}
